import {useEffect, useRef, useState} from "react";
import {BorderlessButton} from "../react-button-package/ButtonPackage";

import './DropdownMenu.css'

const DropdownMenu = ({buttonText, options = Array<any>(), triggerOnHover = false}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [direction, setDirection] = useState('right');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // @ts-ignore
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (dropdownRef.current) {
            // @ts-ignore
            const rect = dropdownRef.current.getBoundingClientRect();
            const spaceRight = window.innerWidth - rect.right;
            const spaceLeft = rect.left;

            setDirection(spaceRight > spaceLeft ? 'right' : 'left');
        }
    }, [isOpen]);

    const toggleDropdown = (event) => {
        event.stopPropagation();

        setIsOpen(!isOpen);
    };

    return (
        <div
            className="dropdown"
            ref={dropdownRef}
            // @ts-ignore
            onMouseEnter={triggerOnHover ? toggleDropdown : null}
            // @ts-ignore
            onMouseLeave={triggerOnHover ? toggleDropdown : null}
        >
            <BorderlessButton
                onPress={triggerOnHover ? null : toggleDropdown}
                text={buttonText}
            />
            {isOpen && (
                <div className={`dropdown-content ${direction}`}>
                    {
                        options.map(option => <BorderlessButton
                            // @ts-ignore
                            text={option.text}
                            // @ts-ignore
                            onPress={(event) => {
                                event.stopPropagation();

                                option.onPress(event)
                            }}
                            // @ts-ignore
                            style={{ padding: '10px 15px', ...option.style }}
                            // @ts-ignore
                            textStyle={{ ...option.textStyle }}
                        />)
                    }
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;